var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-page" }, [
    _c("div", { staticClass: "card-panel mb16" }, [
      _c(
        "div",
        { staticClass: "tabs-filter" },
        [
          _c("Search", {
            ref: "unpaidSearchForm",
            attrs: { pageEntry: "unpaid" },
            on: { getList: _vm.getList },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "card-panel" },
      [
        _c("z-table", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.orderList,
            columns: _vm.columns,
            pagination: _vm.pagination,
          },
          on: {
            "update:pagination": function ($event) {
              _vm.pagination = $event
            },
            "page-change": _vm.handlePageChange,
          },
          scopedSlots: _vm._u([
            {
              key: "orderNo",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "p",
                    [
                      _c("span", { staticClass: "item-orderNo" }, [
                        _vm._v(_vm._s(row.orderNo)),
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "复制订单编号",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont iconcopy",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return function () {
                                  return _vm.handleCopy(row.orderNo)
                                }.apply(null, arguments)
                              },
                            },
                          }),
                        ]
                      ),
                      row.riskStatus
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("风险订单"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "shipmentStatus",
              fn: function (ref) {
                var row = ref.row
                return [
                  _vm._v(
                    " " +
                      _vm._s(row.shipmentStatus ? row.shipmentStatus : "-") +
                      " "
                  ),
                ]
              },
            },
            {
              key: "payTotalAmount",
              fn: function (ref) {
                var row = ref.row
                return [
                  _vm._v(_vm._s(row.symbol || "") + _vm._s(row.payTotalAmount)),
                ]
              },
            },
            {
              key: "paidMultiplied",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", [
                    _vm._v(_vm._s(row.paidMultiplied === true ? "是" : "否")),
                  ]),
                ]
              },
            },
            {
              key: "spuCodes",
              fn: function (ref) {
                var row = ref.row
                return [
                  row.spuCodes && row.spuCodes.length === 1
                    ? _c("p", [_vm._v(_vm._s(row.spuCodes[0]))])
                    : row.spuCodes && row.spuCodes.length > 0
                    ? _c(
                        "p",
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: row.spuCodes.join("，"),
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(row.spuCodes[0]) + "..."),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("p", [_vm._v("-")]),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }